import { Formik } from "formik";
import  { useState } from "react";
import { Col, Form, Row, Button, Spinner, Modal } from "react-bootstrap";
import style from "./cotactus.module.css";
import * as Yup from "yup";
import { sendMessage } from "../../apis/authApis";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";

const ContactUs = () => {
  const dispatch = useDispatch();
  const [disableButton, setDisableButton] = useState(false);
  const [showStartCampaignModal, setShowStartCampaignModal] = useState(false);

  return (
    <>
      <Helmet>
        <title>Contact Us for Support, Feedback & Community Campaigns.</title>
         <meta name="description"content="Need help, have feedback, or want to share your story? Contact FundLife to connect with the team behind campaigns for church, family, and community causes. We’re here to respond to inquiries and support mission-driven fundraisers." />
    {/* <meta property="og:description" content="Have questions? Reach out to us! Fill out the form with your name, email, and message, and we’ll get back to you as soon as possible." /> */}
    <meta name="keywords" content=" fundlife contact, fundraising support, platform help, campaign questions, church fundraising support, family campaign inquiries, community campaign contact"/> 
      </Helmet>
      <div>
        <div className={style.banner}>
          <div style={{ height: "150px" }} />
          <div className=" innercontainer pt-5 px-3 ">
            <div>
              <div className="fs-1 fw-bold text-white">
                Let’s Connect — Together <br/> We Can Spark Change.
              </div>
              <div className="text-white fs-4 my-2">
                Have questions, ideas, or a story to share? We’d love to hear
                from you.
              </div>
            </div>
          </div>
        </div>
        <Row className="m-0 p-0">
          <Col md={12} style={{ backgroundColor: "rgb(250, 250, 251)" }}>
            <div className="d-flex justify-content-center ">
              <div className="m-auto">
                <h3 className="text-center mt-5 mb-4 ">
                  We’re here to help and answer
                  <br />
                  any questions you might have.
                </h3>
                <Formik
                  initialValues={{
                    name: "",
                    email: "",
                    message: "",
                    campaignSupport: false,
                    campaignUpdates: false,
                    startCampaign: false,
                    reportCampaign: false,
                    feedback: false,
                  }}
                  validationSchema={Yup.object().shape({
                    name: Yup.string().max(255).required("Name is required"),
                    message: Yup.string().required("Message is required"),
                    email: Yup.string()
                      .email("Must be a valid email")
                      .max(255)
                      .required("Email is required"),
                  })}
                  onSubmit={async (
                    values,
                    { setErrors, setStatus, setSubmitting, resetForm }
                  ) => {
                    try {
                      setDisableButton(true);
                      setStatus({ success: false });
                      setSubmitting(false);
                      dispatch(sendMessage(values)).then(() => {
                        setDisableButton(false);
                        resetForm();
                      });
                    } catch (err) {
                      setStatus({ success: false });
                      setErrors({ submit: err.message });
                      setSubmitting(false);
                      setDisableButton(false);
                    }
                  }}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    touched,
                    values,
                  }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                      <Form.Group className="mb-4" controlId="formBasicName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          className={
                            touched.name && errors.name ? "is-invalid" : ""
                          }
                          value={values.name}
                          name="name"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.name && errors.name)}
                        />
                        {touched.name && errors.name && (
                          <Form.Text className=" text-danger">
                            {errors.name}
                          </Form.Text>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label>Email </Form.Label>
                        <Form.Control
                          className={
                            touched.email && errors.email ? "is-invalid" : ""
                          }
                          type="email"
                          value={values.email}
                          name="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.email && errors.email)}
                        />
                        {touched.email && errors.email && (
                          <Form.Text className=" text-danger">
                            {errors.email}
                          </Form.Text>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-4">
                        <Form.Check
                          type="checkbox"
                          id="campaignSupport"
                          label="I need campaign support."
                          name="campaignSupport"
                          checked={values.campaignSupport}
                          onChange={handleChange}
                          className="mb-2"
                        />
                        <Form.Check
                          type="checkbox"
                          id="campaignUpdates"
                          label="I would like campaign updates."
                          name="campaignUpdates"
                          checked={values.campaignUpdates}
                          onChange={handleChange}
                          className="mb-2"
                        />
                        <Form.Check
                          type="checkbox"
                          id="startCampaign"
                          label="I have a life-affirming organization, and I would like to start a campaign."
                          name="startCampaign"
                          checked={values.startCampaign}
                          onChange={(e) => {
                            handleChange(e);
                            if (e.target.checked) {
                              setShowStartCampaignModal(true);
                            }
                          }}
                          className="mb-2"
                        />
                        <Form.Check
                          type="checkbox"
                          id="reportCampaign"
                          label="I would like to report a campaign."
                          name="reportCampaign"
                          checked={values.reportCampaign}
                          onChange={handleChange}
                          className="mb-2"
                        />
                        <Form.Check
                          type="checkbox"
                          id="feedback"
                          label="I have feedback that I would like to speak to someone about."
                          name="feedback"
                          checked={values.feedback}
                          onChange={handleChange}
                          className="mb-2"
                        />
                      </Form.Group>

                      <Form.Group className="mb-4" controlId="formBasicmessage">
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          className={
                            touched.message && errors.message
                              ? "is-invalid"
                              : ""
                          }
                          value={values.message}
                          name="message"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.message && errors.message)}
                        />
                        {touched.message && errors.message && (
                          <Form.Text className=" text-danger">
                            {errors.message}
                          </Form.Text>
                        )}
                      </Form.Group>
                      <Button
                        className="w-100 redbtn"
                        variant="danger"
                        type="submit"
                        disabled={disableButton}
                      >
                        Send Message
                        {disableButton && (
                          <Spinner
                            className="ms-3"
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </Button>
                    </Form>
                  )}
                </Formik>
                <div className="text-center mt-3 mb-4"></div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Modal
        show={showStartCampaignModal}
        onHide={() => setShowStartCampaignModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-danger fw-bold">Application Status</Modal.Title>
        </Modal.Header>
        <Modal.Body className="fs-5 text-center py-4">
          We are not currently accepting applications, but encourage you to leave your information for us to reach out in the future.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger redbtn px-4" onClick={() => setShowStartCampaignModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ContactUs;
